module.exports = __webpack_public_path__ + "img/AC_S5_Calendar.1741217d.jpg";